import { CurrentMonthEarnings } from './current-month-earnings'
import { LastEdgeRedemptions } from './last-edge-redemptions'
import { UnverifiedAccounts } from './unverified-accounts'

export const RewardsStats = () => {
  return (
    <div className="flex flex-nowrap gap-4 md:flex-wrap">
      <CurrentMonthEarnings />
      <LastEdgeRedemptions />
      <UnverifiedAccounts />
    </div>
  )
}
